import { render, staticRenderFns } from "./ButtonSmall.vue?vue&type=template&id=fa987cf4"
import script from "./ButtonSmall.vue?vue&type=script&lang=ts"
export * from "./ButtonSmall.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports